<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '~/utils';

const props = defineProps<{
	class?: HTMLAttributes['class'];
}>();
</script>

<template>
	<div :class="cn('absolute inset-x-[2px] bottom-[2px] z-20', props.class)">
		<div class="h-[2px] w-full overflow-hidden">
			<div class="h-full w-full animate-video-loading-bar bg-white" />
		</div>
	</div>
</template>
